// RestoreCustomer.tsx
/**
 * Description  : Confirmation pop-up to be prompted when restoring a deleted account within Member Page
 * Date Created : 5/6/2025
 * Author       : SAPPOT Shao Le
 */

import React from "react";
import { Modal, Title, Group, Button } from "@mantine/core";
import classes from "./restore.module.css"; // Make sure to adjust the import path

interface RestoreCustomerProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RestoreCustomer: React.FC<RestoreCustomerProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose}>
      <Title className={classes.title} order={4}>
        Are you sure you want to restore this item?
      </Title>
      <Group className={classes.buttonPart}>
        <Button onClick={onClose} className={classes.buttonCancel}>
          Cancel
        </Button>
        <Button onClick={onConfirm} className={classes.buttonRestore}>
          Restore
        </Button>
      </Group>
    </Modal>
  );
};

export default RestoreCustomer;
